import React from 'react';
export function ArrowUpRightIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.33 6.118l-10-.014a1 1 0 10-.003 2l7.585.01-8.203 8.18a1 1 0 101.414 1.415l8.205-8.18-.015 7.588a1 1 0 102 .003l.016-10a1 1 0 00-1-1l.001-.002z"
  }));
}